import { z } from "zod";

import { normalizeBdPhone } from "../validators/phone";

const TLD_REGEX = /\.[a-zA-Z]{2,}$/;

function isValidEmail(value: string): boolean {
  return (
    z.string().email().safeParse(value).success &&
    TLD_REGEX.test(value.split("@").pop() ?? "")
  );
}

/**
 *
 */
export function detectIdentifierType(value: string): "email" | "phone" {
  return normalizeBdPhone(value.trim()) ? "phone" : "email";
}

const emailOrPhoneSchema = z
  .string()
  .min(1, "Please enter your email or phone number")
  .refine(
    (val) => {
      const trimmed = val.trim();

      if (normalizeBdPhone(trimmed)) {
        return true;
      }

      return isValidEmail(trimmed.toLowerCase());
    },
    {
      message: "Please enter a valid email address or Bangladeshi phone number",
    }
  );

// Sign In schema
export const signInSchema = z.object({
  emailOrPhone: emailOrPhoneSchema,
  password: z.string().min(6, "Password must be at least 6 characters"),
});

// Sign Up schema
export const signUpSchema = z.object({
  name: z.string().trim().min(2, "Name must be at least 2 characters"),
  emailOrPhone: emailOrPhoneSchema,
  password: z.string().min(6, "Password must be at least 6 characters"),
});

// Forgot Password schema
export const forgotPasswordSchema = z.object({
  emailOrPhone: emailOrPhoneSchema,
});

// Reset Password schema
/**
 *
 */
export const resetPasswordSchema = z
  .object({
    password: z.string().min(6, "Password must be at least 6 characters"),
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"],
  });

// Type exports
/**
 *
 */
export type SignInData = z.infer<typeof signInSchema>;

/**
 *
 */
export type SignUpData = z.infer<typeof signUpSchema>;

/**
 *
 */
export type ForgotPasswordData = z.infer<typeof forgotPasswordSchema>;

/**
 *
 */
export type ResetPasswordData = z.infer<typeof resetPasswordSchema>;
